/* eslint-disable */
window.$ = window.jQuery = require('jquery');

require('./libs/libs');
require('./core/core');
require('./modules/modules');
require('../common/modules/modules');

import * as Sentry from '@sentry/browser';
import { filterBotEvents } from '../global-state/helpers/eventsFilter';

Sentry.init({
    dsn: process.env.SENTRY_DNS,
    tracesSampleRate: 1,
    environment: process.env.MODE,
    beforeSend: filterBotEvents,
});

console.log('webpack');
